(function () {
  'use strict';

  function cards(track) {
    return Array.prototype.filter.call(track.children, function (node) {
      return node.matches('[data-pf-list-item], .pf-profile__product') && !node.hidden;
    });
  }

  function enhance(root) {
    root.querySelectorAll('[data-pf-carousel]').forEach(function (carousel) {
      if (carousel.__pfCarousel) return;
      var track = carousel.querySelector('[data-pf-carousel-track]');
      var controls = carousel.querySelector('[data-pf-carousel-controls]');
      if (!track || !controls) return;
      var previous = controls.querySelector('[data-pf-carousel-previous]');
      var next = controls.querySelector('[data-pf-carousel-next]');
      if (!previous || !next) return;

      function update() {
        var available = cards(track).length > 1 && track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !available;
        previous.disabled = !available || track.scrollLeft <= 2;
        next.disabled = !available || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function move(direction) {
        var item = cards(track)[0];
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      new MutationObserver(update).observe(track, { childList: true, attributes: true, subtree: false });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      carousel.__pfCarousel = true;
      requestAnimationFrame(update);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  else enhance(document);
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target || document); });
  document.addEventListener('pf:recently-viewed:rendered', function () { enhance(document); });
})();
